import { Container } from '@workramp/ui';
import styled from 'styled-components';
import { BaseThemeIconButton } from '~/clc/features/theming/learner/components';
import { Carousel } from '~/elc/features/learner-development/components';
import { CustomPageCard } from '~/features/learner-pages';

export const StyledSection = styled.section<{ $backgroundColor?: string }>`
  padding: ${({ theme }) => theme.spacing(6)}px ${({ theme }) => theme.spacing(10)}px;
  background-color: ${({ $backgroundColor, theme }) => $backgroundColor || theme.colors.on[50]};
`;

export const StyledSectionInnerContainer = styled(Container)`
  max-width: ${({ theme }) => theme.spacing(320)}px;
`;

export const StyledIconLeftButton = styled(BaseThemeIconButton)`
  position: absolute;
  left: -${({ theme }) => theme.spacing(12)}px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
  border-radius: 50%;
  box-shadow: ${({ theme }) => theme.shadows[400]};
`;

export const StyledIconRightButton = styled(BaseThemeIconButton)`
  position: absolute;
  right: -${({ theme }) => theme.spacing(12)}px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
  border-radius: 50%;
  box-shadow: ${({ theme }) => theme.shadows[400]};
`;

export const StyledCustomCard = styled(CustomPageCard)`
  width: 100%;
`;

export const StyledCarousel = styled(Carousel)`
  width: calc(100% - ${({ theme }) => theme.spacing(24)}px);
  margin-left: auto;
  margin-right: auto;

  .AL_Custom_SingleCard {
    margin-bottom: 0;
  }
`;
